import BunkeyAPI from '../api/BunkeyAPI'
import {
  TOURS_DASHBOARD,
  TOURS_MENU,
  TOURS_EXPLORE,
  TOURS_USERS,
  TOURS_GROUPS,
  TOURS_DASHBOARD_SUCCESS,
  TOURS_DASHBOARD_FAILURE,
  TOURS_MENU_SUCCESS,
  TOURS_MENU_FAILURE,
  TOURS_EXPLORE_SUCCESS,
  TOURS_EXPLORE_FAILURE,
  TOURS_USERS_SUCCESS,
  TOURS_USERS_FAILURE,
  TOURS_GROUPS_SUCCESS,
  TOURS_GROUPS_FAILURE,
  TOURS_MENU_FILTERS,
  TOURS_MENU_STATE,
  TOURS_DASHBOARD_FILTERS,
  TOURS_DASHBOARD_STATE,
  TOURS_MENU_ONLY_VIEW
} from '../constants/tours-types'

export const getTourDashboard = (user_id) => {
  return dispatch => {
    dispatch({ type: TOURS_DASHBOARD })
    BunkeyAPI({
      url: `users/${user_id}/tour/dashboard`,
      method: 'GET',
    }).then(resp => {
      const toursDashborad = resp.data.steps.map(r => {
         return {
          key: r.number,
          number: r.number,
          selector: r.selector,
          description: r.content,
          title: r.title,
          position: r.position,
          type_user: r.type_user,
        }
      })
      dispatch({
        type: TOURS_DASHBOARD_SUCCESS,
        payload: {
          data: toursDashborad,
          headers: resp.headers
        }
      })
      // if (toursDashborad) {
        // dispatch(setToursDashboardFilters(toursDashborad))
      // }
    }).catch(err => {
      dispatch({
        type: TOURS_DASHBOARD_FAILURE,
        payload: err
      })
    })
  }
}
export const getTourMenu = (user_id) => {
  return dispatch => {
    dispatch({ type: TOURS_MENU })
    BunkeyAPI({
      url: `users/${user_id}/tour/menu`,
      method: 'GET',
    }).then(resp => {
      const toursMenu = resp.data.steps.map(r => {
         return {
          key: r.number,
          number: r.number,
          selector: r.selector,
          description: r.content,
          title: r.title,
          position: r.position,
          type_user: r.type_user,
        }
      })
      dispatch({
        type: TOURS_MENU_SUCCESS,
        payload: {
          data: toursMenu,
          headers: resp.headers
        }
      })
      // if (toursMenu) {
        // dispatch(setToursMenuFilters(toursMenu))
      // }
    }).catch(err => {
      dispatch({
        type: TOURS_MENU_FAILURE,
        payload: err
      })
    })
  }
}
export const getTourUsers = (user_id) => {
  return dispatch => {
    dispatch({ type: TOURS_USERS })
    BunkeyAPI({
      url: `users/${user_id}/tour/users`,
      method: 'GET',
    }).then(resp => {
      const toursUsers = resp.data.steps.map(r => {
         return {
          key: r.number,
          number: r.number,
          selector: r.selector,
          description: r.content,
          title: r.title,
          position: r.position,
        }
      })
      dispatch({
        type: TOURS_USERS_SUCCESS,
        payload: {
          data: toursUsers,
          headers: resp.headers
        }
      })
    }).catch(err => {
      dispatch({
        type: TOURS_USERS_FAILURE,
        payload: err
      })
    })
  }
}
export const getTourGroups = (user_id) => {
  return dispatch => {
    dispatch({ type: TOURS_GROUPS })
    BunkeyAPI({
      url: `users/${user_id}/tour/groups`,
      method: 'GET',
    }).then(resp => {
      const toursGroups = resp.data.steps.map(r => {
         return {
          key: r.number,
          number: r.number,
          selector: r.selector,
          description: r.content,
          title: r.title,
          position: r.position,
        }
      })
      dispatch({
        type: TOURS_GROUPS_SUCCESS,
        payload: {
          data: toursGroups,
          headers: resp.headers
        }
      })
    }).catch(err => {
      dispatch({
        type: TOURS_GROUPS_FAILURE,
        payload: err
      })
    })
  }
}
export const getTourExplore = (user_id) => {
  return dispatch => {
    dispatch({ type: TOURS_EXPLORE })
    BunkeyAPI({
      url: `users/${user_id}/tour/explore`,
      method: 'GET',
    }).then(resp => {
      const toursExplore = resp.data.steps.map(r => {
         return {
          key: r.number,
          number: r.number,
          selector: r.selector,
          description: r.content,
          title: r.title,
          position: r.position,
        }
      })
      dispatch({
        type: TOURS_EXPLORE_SUCCESS,
        payload: {
          data: toursExplore,
          headers: resp.headers
        }
      })
    }).catch(err => {
      dispatch({
        type: TOURS_EXPLORE_FAILURE,
        payload: err
      })
    })
  }
}

export const editTourDashboard = (user_id, steps) => {
  return (dispatch) => {
    BunkeyAPI({
      url: `users/${user_id}/tour`,
      method: 'PUT',
      data: {
        steps,
      },
    })
      .then((resp) => {
        dispatch(getTourDashboard(user_id))
      })
      .catch((err) => { })
  }
}
export const editTourMenu = (user_id, steps) => {
  return (dispatch) => {
    BunkeyAPI({
      url: `users/${user_id}/tour`,
      method: 'PUT',
      data: {
        steps: steps,
      },
    })
      .then((resp) => {
        dispatch(getTourMenu(user_id))
      })
      .catch((err) => { })
  }
}
export const editTourUsers = (user_id, steps) => {
  return (dispatch) => {
    BunkeyAPI({
      url: `users/${user_id}/tour`,
      method: 'PUT',
      data: {
        steps,
      },
    })
      .then((resp) => {
        dispatch(getTourUsers(user_id))
      })
      .catch((err) => { })
  }
}
export const editTourGroups = (user_id, steps) => {
  return (dispatch) => {
    BunkeyAPI({
      url: `users/${user_id}/tour`,
      method: 'PUT',
      data: {
        steps,
      },
    })
      .then((resp) => {
        dispatch(getTourGroups(user_id))
      })
      .catch((err) => { })
  }
}
export const editTourExplore = (user_id, steps) => {
  return (dispatch) => {
    BunkeyAPI({
      url: `users/${user_id}/tour`,
      method: 'PUT',
      data: {
        steps,
      },
    })
      .then((resp) => {
        dispatch(getTourExplore(user_id))
      })
      .catch((err) => { })
  }
}

export const setToursMenuFilters = toursMenu => {
  // const { authUser } = JSON.parse(localStorage.getItem('state'));
  // var newMenus = []
  // if (authUser && authUser.user && toursMenu) {
  //   var type_user = null;
  //   if (authUser.user.role === 'admin') {
  //     type_user = 'superadmin'
  //   } else {
  //     type_user = authUser.user.clientRole
  //   }
  //   toursMenu.forEach((r) => {
  //     r.classname = 's_menu_' + r.number
  //     if (r.type_user === 'all') {
  //       newMenus.push({...r})
  //     } else {
  //       if (type_user === r.type_user) {
  //         newMenus.push({...r})
  //       }
  //       if ((type_user === 'admin' || type_user === 'superadmin') && r.type_user === 'su-admin') {
  //         newMenus.push({...r})
  //       }
  //     }
  //   })
  // }
  return dispatch => {
    dispatch({type: TOURS_MENU_FILTERS, payload: {data: toursMenu}})
  }
}

export const setStatusTourMenu = state => {
  return dispatch => {
    dispatch({type: TOURS_MENU_STATE, payload: {data: state}})
  }
}
export const setToursDashboardFilters = toursdashboard => {
  // const { authUser } = JSON.parse(localStorage.getItem('state'));
  // var newDashboard = []
  // if (authUser && authUser.user && toursdashboard ) {
  //   var type_user = null;
  //   if (authUser.user.role === 'admin') {
  //     type_user = 'superadmin'
  //   } else {
  //     type_user = authUser.user.clientRole
  //   }
  //   toursdashboard.forEach((r) => {
  //     r.classname = 's_menu_' + r.number
  //     if (r.type_user === 'all') {
  //       newDashboard.push({...r})
  //     } else {
  //       if (type_user === r.type_user) {
  //         newDashboard.push({...r})
  //       }
  //       if ((type_user === 'admin' || type_user === 'superadmin') && r.type_user === 'su-admin') {
  //         newDashboard.push({...r})
  //       }
  //     }
  //   })
  // }
  return dispatch => {
    dispatch({type: TOURS_DASHBOARD_FILTERS, payload: {data: toursdashboard}})
  }
}

export const setStatusTourDashboard = state => {
  return dispatch => {
    dispatch({type: TOURS_DASHBOARD_STATE, payload: {data: state}})
  }
}
export const viewOnlyOnceTourMenu = (value = true) => {
  return dispatch => {
    dispatch({type: TOURS_MENU_ONLY_VIEW, payload: {tourMenuOnlyView: value}})
  }
}
